import React from 'react'

import Sectiontitle from './sectionTitle'
import '../sass/partials/contact.scss'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faMapMarker } from '@fortawesome/fontawesome-free-solid'

const Logo = () => (
    <section className="contact__map">
        <div className="contact__map__details">
            <div className="container">
                <div className="text rc-copy">
                    <Sectiontitle title="Find Us at" icon={faMapMarker} color="yellow"/>

                    373 Meadow Lane<br/>
                    Oxford<br/>
                    OX4 4BL
                </div>
            </div>
        </div>
    </section>
)

export default Logo



// WEBPACK FOOTER //
// ./src/components/contactmap.js